if (!customElements.get('gg-model-menu')) {
  customElements.define('gg-model-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      if (!tabs.length || tabs.length !== panels.length) return;
      const activate = index => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].inert = i !== index;
          panels[i].setAttribute('aria-hidden', String(i !== index));
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(next);
          tabs[next].focus();
        });
      });
      this.dataset.enhanced = 'true';
      activate(0);
    }
  });
}
